import templeImg from "../../../assets-user/temple.png";
import advertisement_2 from "../../../assets-user/home/advertisement_2.png";
import { useAppContext } from "../../../context/AppContext";

const ExploreLocations = () => {
  const { ads, adsLoading } = useAppContext();

  const locations = [
    { img: templeImg, name: "Sundarpada", properties: "2,000+ Properties" },
    { img: templeImg, name: "Kalinga Nagar", properties: "2,000+ Properties" },
    { img: templeImg, name: "Saheed Nagar", properties: "2,000+ Properties" },
    { img: templeImg, name: "Fire Station", properties: "2,000+ Properties" },
    { img: templeImg, name: "Patia", properties: "2,000+ Properties" },
    { img: templeImg, name: "Acharya Bihar", properties: "2,000+ Properties" },
    { img: templeImg, name: "Nayapali", properties: "2,000+ Properties" },
    { img: templeImg, name: "Baramunda", properties: "2,000+ Properties" },
  ];

  return (
    <section className="w-full bg-white flex flex-col md:flex-row gap-4 px-4 sm:px-6 md:px-8 lg:px-10 py-6 md:py-8 lg:py-10">
      {/* Main */}
      <div className="flex-1 flex-col items-start gap-4">
        {/* Header */}
        <h2 className="font-medium text-[#031722] pb-6 md:pb-8 lg:pb-10 text-lg sm:text-xl md:text-2xl text-start">
          Explore popular Location in Odisha
        </h2>
        {/* Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 xl:gap-4">
          {locations.map((location, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col md:flex-row items-center hover:shadow-lg transition duration-300"
            >
              {/* Image */}
              <img
                src={location.img}
                alt={location.name}
                className="w-28 md:w-24 md:h-24  object-cover rounded-lg md:rounded-none"
              />

              {/* Text */}
              <div className="flex-1 p-3">
                <h3 className="font-medium text-center md:text-left text-[#031722] text-base mb-1 leading-tight line-clamp-1">
                  {location.name}
                </h3>

                <p className="text-text-muted text-center md:text-left text-xs line-clamp-1">
                  {location.properties}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Advertisement */}
      <div className="overflow-hidden md:h-[19rem] rounded-xl">
        {adsLoading ? (
          <div className="w-full h-full animate-pulse bg-gray-200 rounded-xl" />
        ) : (
          <img
            src={ads?.bottomAdUrl || advertisement_2}
            alt="advertisement"
            className="w-full h-full object-cover"
          />
        )}
      </div>
    </section>
  );
};

export default ExploreLocations;

// import React, { useState, useEffect } from "react";
// import templeImg from "../../../assets-user/temple.png";

// const ExploreLocations = () => {
//   const [loading, setLoading] = useState(true);

//   const locations = [
//     { img: templeImg, name: "Sundarpada", properties: "2,000+ Properties" },
//     { img: templeImg, name: "Kalinga Nagar", properties: "2,000+ Properties" },
//     { img: templeImg, name: "Saheed Nagar", properties: "2,000+ Properties" },
//     { img: templeImg, name: "Fire Station", properties: "2,000+ Properties" },
//     { img: templeImg, name: "Patia", properties: "2,000+ Properties" },
//     { img: templeImg, name: "Acharya Bihar", properties: "2,000+ Properties" },
//     { img: templeImg, name: "Nayapali", properties: "2,000+ Properties" },
//     { img: templeImg, name: "Baramunda", properties: "2,000+ Properties" },
//   ];

//   useEffect(() => {
//     const timer = setTimeout(() => setLoading(false), 300);
//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <section
//       className="w-full bg-white px-4 sm:px-6 md:px-8 lg:px-10 py-6 md:py-8 lg:py-10"
//       data-aos="fade-up"
//     >
//       <div className="mx-auto">
//         <div className="flex justify-between items-center py-4 md:py-6 lg:py-8">
//           <h2 className="font-medium text-[#031722] text-lg sm:text-xl md:text-2xl ">
//             Explore popular Location in Odisha
//           </h2>
//         </div>

//         {loading ? (
//           <div
//             className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 lg:gap-6"
//             data-aos="fade-in"
//           >
//             {[...Array(8)].map((_, i) => (
//               <div
//                 key={i}
//                 className="bg-white rounded-xl shadow-md overflow-hidden h-20 sm:h-24 flex items-center gap-4 p-3 sm:p-4"
//               >
//                 <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gray-200 rounded-lg" />
//                 <div className="flex-1 min-w-0 space-y-2">
//                   <div className="h-4 bg-gray-200 rounded w-3/4" />
//                   <div className="h-3 bg-gray-200 rounded w-1/2" />
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div
//             className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5 lg:gap-6"
//             data-aos="zoom-in-up"
//           >
//             {locations.map((location, index) => (
//               <div
//                 key={index}
//                 className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col md:flex-row items-center gap-4 md:gap-6 p-4 md:p-6 hover:shadow-lg transition duration-300"
//                 data-aos="zoom-in"
//                 data-aos-delay={index * 100}
//               >
//                 <div
//                   className="relative flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 overflow-hidden rounded-lg"
//                   data-aos="fade-right"
//                 >
//                   <img
//                     src={location.img}
//                     alt={location.name}
//                     className="w-full h-full object-cover"
//                   />
//                 </div>

//                 <div className="flex-1 min-w-0" data-aos="fade-left">
//                   <div className="flex justify-center md:justify-start">
//                     <h3 className="font-medium text-[#031722] text-base sm:text-lg md:text-xl lg:text-[18.7px] mb-2 leading-tight truncate">
//                       {location.name}
//                     </h3>
//                   </div>
//                   <p className="font-normal text-[#6A6A6A] text-sm sm:text-base md:text-[14.54px] mb-0 truncate">
//                     {location.properties}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default ExploreLocations;
